import { Adapter } from "@/core/models/adapter";

export const CONNECTOR_PREMIUM_FEATURE_BUSINESS = "connector_premium_feature_business";
export const CONNECTOR_PREMIUM_FEATURE_COMPONENT = "connector_premium_feature_component";

// ACTIONS FRONT
export const ACTION_SEARCH_BAR = "SearchBar";

// ACTIONS BACK
export const ACTION_GET_PAYMENT_FROM_PROVIDER = "get_payment_from_provider";
export const ACTION_GET_PREMIUM_FEATURE_ACTIVE = "get_premium_feature_active";
export const ACTION_CIRCUIT_EDIT_INPUT = "get_circuit_input";
export const ACTION_EDIT_CIRCUIT = "edit_circuit";
export const ACTION_COMPUTE_DEPOSIT_BONUS = "compute_deposit_bonus";

/* Refurb Connector Related */
export const IS_ADVANCED_STOCKS_ENABLED = "is_advanced_stocks_enabled";
export const IS_REFURB_DIAGNOSIS_ENABLED = "is_refurb_diagnosis_enabled";
export const IS_REFURB_STEPS_ENABLED = "is_refurb_steps_enabled";

export class Connector {
  constructor() {
    this.id = null;
    this.name = null;
    this.fqn = null;
    this.service = null;
    this.type = null;
    this.privateConfig = null;
    this.connectorOrganizations = null;
  }
}

export class ConnectorAdapter extends Adapter {
  static adapt(connectorApi) {
    const connector = new Connector();
    connector.id = connectorApi?.id;
    connector.name = connectorApi?.name;
    connector.fqn = connectorApi?.fqn;
    connector.service = connectorApi?.service;
    connector.type = connectorApi?.type;
    connector.privateConfig = connectorApi?.privateConfig;
    connector.connectorOrganizations = connectorApi?.connectorOrganizations;

    return connector;
  }
}
